import React, { Component } from 'react'
import { connect } from 'react-redux'
import Password from './Password/index.jsx'
import EPassport from './ePassport/components/ePassport.jsx'
import DataProtection from './DataProtection/index.jsx'
import DataConstructor from './DataConstructor/index.jsx'
import { profileData } from './Password/fixtures.js'
import {
    getUserData,
    getPersonalData,
    UserData,
} from '../../redux/actions/items.js'

class componentList extends Component {
    constructor(props) {
        super(props)

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    componentDidUpdate(prevProps, prevState) {
        let { match, selectedTab, switchSelectedTab } = this.props
        if (match.params.id !== selectedTab) {
            switchSelectedTab(match.params.id)
        }
    }

    render() {
        let { id } = this.props.match.params
        return (
            <div className="profile__data-container">
                {this.dataProtection()
                    ? this.dataProtectionComponent()
                    : this.renderSwitch(id)}
            </div>
        )
    }

    renderSwitch = id => {
        let {
            userData,
            tfaType,
            tfaCodeRequestRequired,
            getStatus,
        } = this.props

        switch (id) {
            case 'epassport':
                return (
                    <div id="ePassportPlus-container">
                        <EPassport />
                    </div>
                )
                break
            default:
                return (
                    <DataConstructor
                        id={id}
                        profileData={this.tabDataСonversion(id)}
                        dataProtection={this.dataProtection}
                        phoneVerificationRequired={
                            userData['phone_verification_required']
                        }
                        tfaCodeRequestRequired={tfaCodeRequestRequired}
                        tfaType={tfaType}
                        getStatus={getStatus}
                    />
                )
        }
    }

    dataProtectionComponent = () => {
        let {
            userData: userDataObj,
            UserData,
            tfaType,
            getStatus,
            tfaCodeRequestRequired,
        } = this.props
        let { error } = userDataObj

        return (
            <DataProtection
                tfaCodeRequestRequired={tfaCodeRequestRequired}
                tfaType={tfaType}
                getStatus={getStatus}
                wrongCode={error === 'wrong_2fa_code' ? error : ''}
                UserData={UserData}
            />
        )
    }

    dataProtection = update => {
        let { getPersonalData, userData: userDataObj } = this.props
        let { success, error } = userDataObj
        let { userData, personalData } = success
        let { session_2fa_personaldata_until, datetime } = JSON.parse(
            localStorage['settings_page_UserData.session'] || '{}'
        )

        if (userData && personalData && update === undefined) {
            return false
        } else if (
            error !== '2fa_session_timeout' &&
            localStorage['settings_page_UserData.session'] &&
            session_2fa_personaldata_until - datetime > 0
        ) {
            getPersonalData('continue')
        } else {
            return true
        }
    }

    tabDataСonversion = id => {
        let { userData } = this.props
        let tabDataArray = []

        if (id === 'change_password') {
            tabDataArray = profileData
        } else {
            for (let item in userData[id]) {
                tabDataArray.push(userData[id][item])
            }
        }
        return tabDataArray
    }
}

const mapStateToProps = state => {
    return {
        file: state.addFile,
        removeFile: state.removeFile,
        dataCollection: state.AddFiles,
        userData: state.UserData,
    }
}

const mapDispatchProps = dispatch => {
    return {
        UserData: type => dispatch(UserData(type)),
        getUserData: () => dispatch(getUserData()),
        getPersonalData: code => dispatch(getPersonalData(code)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchProps
)(componentList)
